export default "__VITE_ASSET__BLf3bftR__"